import {
  TOGGLE_NAVIGATION_DRAWER,
  SET_IS_SCROLLED_TO_FOOTER,
  GET_WINDOW_WIDTH,
  GET_WINDOW_HEIGHT,
} from '../mutationTypes';

const moduleLayout = {
  namespaced: true,

  state: {
    navigationDrawerIsVisible: false,
    isScrolledToFooter: false,
    windowSize: {
      width: 0,
      height: 0,
    },
  },

  getters: {

  },

  actions: {

  },

  mutations: {
    [TOGGLE_NAVIGATION_DRAWER](state, payload) {
      state.navigationDrawerIsVisible = payload;
    },
    [SET_IS_SCROLLED_TO_FOOTER](state, payload) {
      state.isScrolledToFooter = payload;
    },
    [GET_WINDOW_WIDTH](state, payload) {
      state.windowSize.width = payload;
    },
    [GET_WINDOW_HEIGHT](state, payload) {
      state.windowSize.height = payload;
    },
    [SET_IS_SCROLLED_TO_FOOTER](state, payload) {
      state.isScrolledToFooter = payload;
    },
  },
};

export default moduleLayout;
